<div class="page-title">
    <button class="btn link-btn btn-back">
        <i class="app-icon icon icon-chevron-left icon-xxl" (click)="backHandler()"></i>
    </button>
    {{'invoice.detail.title' | translate}}
    <span HJSuppress class="invoice-number fw-bold text-primary">
        {{invoice?.number}}
    </span>
</div>

<div class="row row-details">
    <div class="col-lg-6 text-center text-lg-start">
        <div class="subtitle ms-xl-5">
            <span>{{'invoice.detail.client' | translate}}:</span>
            <span HJSuppress class="subtitle-value">
                {{invoice?.clientId}}
            </span>
            <button class="btn copy-clipboard-btn ms-2" [cdkCopyToClipboard]="invoice?.clientId" (click)="showClipboardNotification()">
                <i class="app-icon icon icon-copy icon-md2"></i>
            </button>
        </div>

        <div class="subtitle ms-xl-5" *ngIf="invoice?.contracts?.length > 0">
            <div class="d-flex align-items-center">
                <span>{{'invoice.detail.contract' | translate}}:</span>

                <ng-container *ngFor="let contract of invoice?.contracts | slice: 0 : 2; let last = last">
                    <span HJSuppress class="subtitle-value">
                        {{contract.contractNumber}}
                    </span>
                    <span *ngIf="!last || invoice?.contracts?.length > 2">, </span>
                </ng-container>

                <button *ngIf="invoice?.contracts?.length > 2" 
                    type="button" class="btn view-more-btn ms-2"
                    (click)="openDetailsListModalInvoiceContracts($event, invoice?.contracts)"
                >
                    {{'common.viewMore' | translate}}
                </button>
            </div>
        </div>

        <div class="subtitle ms-xl-5" *ngIf="invoice?.type">
            <span>{{'invoice.type' | translate}}:</span>
            <span HJSuppress class="subtitle-value">
                {{invoice?.type}}
            </span>
        </div>

        <div class="subtitle ms-xl-5" *ngIf="invoice?.categories?.length > 0">
            <span>{{'invoice.category' | translate}}:</span>
            <ng-container *ngFor="let category of invoice?.categories; let last = last">
                <span HJSuppress class="subtitle-value">
                    {{category.type}}
                </span>
                <span *ngIf="!last">, </span>
            </ng-container>
        </div>
    </div>

    <div class="col-lg-6 text-center text-lg-end">
        <div class="subtitle">
            <span>{{'invoice.detail.issuedDate' | translate}}:</span>
            <span HJSuppress class="subtitle-value">
                {{invoice?.issuedDate | localizedDate}}
            </span>
        </div>
        <div class="subtitle">
            <span>{{'invoice.detail.dueDate' | translate}}:</span>
            <span HJSuppress class="subtitle-value due-date">
                {{invoice?.dueDate | localizedDate}}
            </span>
        </div>
        <div class="subtitle d-flex align-items-center justify-content-center justify-content-lg-end">
            <span>{{'invoice.detail.status' | translate}}:</span>
            <div HJSuppress *ngIf="invoice?.isPaid" class="state d-flex align-items-center">
                <i class="app-icon icon icon-check-circle-fill icon-xl paid-icon me-2"></i>
                {{'invoice.status.paid' | translate}}
            </div>
            <div HJSuppress *ngIf="!invoice?.isPaid && !invoice?.isOverdue" class="state d-flex align-items-center">
                <i class="app-icon icon icon-close-circle-fill icon-xl not-paid-icon me-2"></i>
                {{'invoice.status.notPaid' | translate}}
            </div>
            <div HJSuppress *ngIf="invoice?.isOverdue" class="state d-flex align-items-center">
                <i class="app-icon icon icon-warning-triangle-fill icon-xl overdue-icon me-2"></i>
                {{'invoice.status.overdue' | translate}}
            </div>
        </div>
    </div>
</div>

<div class="row row-outstanding-export">
    <div class="col-lg-6 text-center text-lg-start">
        <button class="btn m-outline-btn mt-4 mt-lg-0 ms-xl-5" (click)="exportPDFHandler()">
            <i class="app-icon icon icon-file-pdf icon-lg"></i>
            {{'invoice.detail.exportPDF' | translate}}
        </button>
    </div>
    <div class="col-lg-6 text-center text-lg-end subtitle outstanding-amount">
        {{'invoice.detail.unpaidAmount' | translate}}:
        <span HJSuppress class="subtitle-value-lg">
            {{invoice?.outstandingAmount | number : '1.'}} {{invoice?.currencyCode}}
        </span>
    </div>
</div>

<dynamic-table [props]="props">
    <table class="responsive-table">
        <thead>
            <tr class="table-header">
                <th id="Type" class="table-header-title">
                    {{'invoice.detail.type' | translate}}
                </th>
                <th id="Quantity" class="table-header-title">
                    {{'invoice.detail.quantity' | translate}}
                </th>
                <th id="Interest" class="table-header-title">
                    {{'invoice.detail.unit' | translate}}
                </th>
                <th id="Total" class="table-header-title">
                    {{'invoice.detail.total' | translate}}
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let detail of invoice?.details">
                <tr class="row-container ccc ccc-table-row">
                    <td HJSuppress [attr.data-label]="'invoice.detail.type' | translate" id="Type" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'invoice.detail.type' | translate}}</div>
                            <div class="cell-value">{{detail?.type}}</div>
                        </div>
                    </td>
                    <td HJSuppress [attr.data-label]="'invoice.detail.quantity' | translate" id="Quantity" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'invoice.detail.quantity' | translate}}</div>
                            <div class="cell-value">{{detail?.quantity | number : '1.'}}</div>
                        </div>
                    </td>
                    <td HJSuppress [attr.data-label]="'invoice.detail.unit' | translate" id="Unit" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'invoice.detail.unit' | translate}}</div>
                            <div class="cell-value">{{detail?.unit | number : '1.'}} {{invoice?.currencyCode}}</div>
                        </div>
                    </td>
                    <td HJSuppress [attr.data-label]="'invoice.detail.total' | translate" id="Total" class="column-content">
                        <div class="cell-data">
                            <div class="cell-label">{{'invoice.detail.total' | translate}}</div>
                            <div class="cell-value">{{detail?.total | number : '1.'}} {{invoice?.currencyCode}}</div>
                        </div>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</dynamic-table>

<div class="d-flex justify-content-center justify-content-md-end">
    <table class="total-table">
        <tr>
            <td class="total-name">
                {{'invoice.detail.subtotal' | translate}}
            </td>
            <td HJSuppress class="total-value text-end text-md-start">
                {{invoice?.subtotal | number : '1.'}} {{invoice?.currencyCode}}
            </td>
        </tr>
        <tr>
            <td class="total-name">
                {{'invoice.detail.vat' | translate}}
            </td>
            <td HJSuppress class="total-value text-end text-md-start">
                {{invoice?.vat | number : '1.'}} {{invoice?.currencyCode}}
            </td>
        </tr>
        <tr class="total-row">
            <td class="total-name">
                {{'invoice.detail.totalvat' | translate}}
            </td>
            <td HJSuppress class="total-value text-end text-md-start">
                {{invoice?.total | number : '1.'}} {{invoice?.currencyCode}}
            </td>
        </tr>
    </table>
</div>
